import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const FOOTER_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'Dashboard', to: '/dashboard' },
  { label: 'Insights', to: '/insights' },
  { label: 'Contact', to: '/contact' },
];

export default function Footer() {
  const year = 2026;
  return (
    <footer className="mem-footer">
      <div className="mem-footer__main container">
        <div className="mem-footer__brand">
          <div className="mem-footer__logo">Market Edge Metrics</div>
          <p className="mem-footer__tagline">
            Execution risk &amp; microstructure intelligence for Binance traders.
          </p>
        </div>

        <nav className="mem-footer__nav" aria-label="Footer">
          <ul className="mem-footer__links">
            {FOOTER_LINKS.map(({ label, to }) => (
              <li key={to}>
                <Link to={to}>{label}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="mem-footer__meta">
          <p className="mem-footer__copy">
            © {year} Market Edge Metrics · Melbourne, AU
          </p>
          <a className="mem-footer__email" href="mailto:founder@marketedgemetrics.com">
            founder@marketedgemetrics.com
          </a>
        </div>
      </div>

      <div className="mem-footer__bottom">
        <div className="container mem-footer__bottom-inner">
          <Link to="/contact">Privacy</Link>
          <span aria-hidden className="mem-footer__dot">
            ·
          </span>
          <Link to="/contact">Terms</Link>
        </div>
      </div>
    </footer>
  );
}
